import { createLicenseDeviceApi } from '@platform/billing';
import { apiClient } from '@/shared/api/client';

/**
 * 디바이스락 호출부. SSOT 는 `@platform/billing` (기업콘솔과 같은 계약).
 * 여기서는 이 앱의 apiClient 인스턴스만 주입한다.
 */
export const licenseDeviceApi = createLicenseDeviceApi(apiClient);
